/* XNote proposal: notebook PDP gallery and review paging (sections/xp-notebook-*.liquid). No dependencies.
   - [data-xp-gallery]: a scroll-snap track of full-width slides + thumbnail buttons [data-xp-thumb]. Thumbnails
     scroll the track; swiping/scrolling the track updates aria-current on the thumbnails and .is-current on the
     shown slide.
   - [data-xp-more-list] + [data-xp-more="#list"]: CSS hides items after the third while html.js is set; "Show more"
     reveals three more and focuses the first new review. Without JS every review shows. Phones (≤ 767 px, xp-shop.css)
     show every item in one swipe row and hide the button.
   - .xp-nbrev__text: a quote CSS clamps (five lines for --long ones from 768 px; any quote over three lines on phones)
     gets a "Read more" button that opens it; a quote that fits is marked open (no button). */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const PAGE = 3;

  function initGallery(g) {
    const track = g.querySelector('[data-xp-gallery-track]');
    if (!track) return;
    const slides = Array.from(track.children);
    const thumbs = Array.from(g.querySelectorAll('[data-xp-thumb]'));
    let current = 0;
    // .is-current on the shown slide lets CSS keep a peeking slide's corner tag out of the sliver (≤ 1050 px).
    const mark = (i) => { current = i; thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false')); slides.forEach((s, k) => s.classList.toggle('is-current', k === i)); };
    mark(0);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = Number(t.dataset.xpThumb) || 0;
      const slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
      mark(i);
    }));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting && track.clientWidth) mark(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach((s) => io.observe(s));
    }
    // Keep the shown slide after a resize or rotation (snap points move with the track width).
    if ('ResizeObserver' in window) {
      let w = track.clientWidth;
      new ResizeObserver(() => {
        if (!track.clientWidth || track.clientWidth === w) return;
        w = track.clientWidth;
        track.scrollLeft = slides[current].offsetLeft - slides[0].offsetLeft;
      }).observe(track);
    }
  }

  function initMore(btn) {
    const list = document.querySelector(btn.dataset.xpMore);
    if (!list) return;
    const hidden = () => Array.from(list.children).filter((li, i) => i >= PAGE && !li.classList.contains('is-shown'));
    if (!hidden().length) return;
    btn.hidden = false;
    btn.addEventListener('click', () => {
      const next = hidden().slice(0, PAGE);
      next.forEach((li) => { li.classList.add('is-shown'); initClamps(li); });
      if (next[0]) {
        next[0].setAttribute('tabindex', '-1');
        next[0].focus({ preventScroll: false });
      }
      if (!hidden().length) btn.hidden = true;
    });
  }

  function initClamps(root) {
    root.querySelectorAll('.xp-nbrev__text:not([data-xp-clamp])').forEach((box) => {
      const p = box.querySelector('p');
      if (!p || !p.getClientRects().length) return; // not rendered yet (hidden page): set up when revealed
      box.setAttribute('data-xp-clamp', '');
      if (p.scrollHeight <= p.clientHeight + 2) { box.classList.add('is-open'); return; }
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'xp-link xp-nbrev__readmore';
      more.textContent = 'Read more';
      more.addEventListener('click', () => { box.classList.add('is-open'); more.remove(); p.setAttribute('tabindex', '-1'); p.focus({ preventScroll: true }); });
      box.after(more);
    });
  }

  function init() {
    document.querySelectorAll('[data-xp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-xp-more]').forEach(initMore);
    initClamps(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
